import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import BudgetAndTimelinePanelForm, { FormInitialValues } from "./BudgetAndTimelinePanelForm";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { setCampaignBasicDetails } from "../../../redux/reducers/campaignToCreate";

type Props = {
  submitRef: React.RefObject<HTMLButtonElement>;
};

const BudgetAndTimelinePanel: FC<Props> = ({ submitRef }) => {
  const dispatch = useDispatch();
  const basicDetails = useSelector((state: ReduxApplicationState) => state.campaignToCreate.basicDetails);

  const formInitialValues: FormInitialValues = {
    startDate: basicDetails.startDate,
    endDate: basicDetails.endDate,
    dailyBudget: basicDetails.dailyBudget,
    estimatedBudget: basicDetails.estimatedBudget,
    maxBid: basicDetails.maxBid,
  };

  const handleSubmit = (values: FormInitialValues) => {
    dispatch(
      setCampaignBasicDetails({
        startDate: values.startDate,
        endDate: values.endDate,
        dailyBudget: +values.dailyBudget,
        estimatedBudget: +values.estimatedBudget,
        maxBid: +values.maxBid,
      }),
    );
  };

  return (
    <BudgetAndTimelinePanelForm ref={submitRef} formInitialValues={formInitialValues} handleSubmit={handleSubmit} />
  );
};

export default BudgetAndTimelinePanel;
